"use client";

import { cn } from "@saridana-core/react-ui-kit";
import { HtmlParser } from "../html-parser";

type Props = {
  className?: string;
  title: string;
  titleClassName?: string;
  description?: string;
  descriptionClassName?: string;
};

export function SectionHeading({ title, titleClassName, description, descriptionClassName, className }: Props) {
  return (
    <div className={cn("space-y-6 sm:space-y-[28px]", className)}>
      <h2 className={cn("font-bold text-5xl sm:text-[64px] max-w-3xl mx-auto !leading-[112%]", titleClassName)}>{title}</h2>
      {description && (
        <div className={cn("text-xl sm:text-2xl font-normal", descriptionClassName)}>
          <HtmlParser data={description} />
        </div>
      )}
    </div>
  );
}
